module.exports = __webpack_public_path__ + "static/img/ban-6.2e53020.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-6.png
// module id = upfM
// module chunks = 0